export default __webpack_public_path__ + "static/media/about_2.498f890b.png";